const e = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- guarded by Variants interface above
  (t, a, c) => (n) => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return -- guarded by Variants interface above
    a[
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call -- guarded by Variants interface above
      typeof t == "function" ? t(n) : n[t] ?? c
    ]
  )
);
export {
  e as variants
};
